import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async count({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.application-detail.count'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getAll({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.application-detail.all'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async paginate({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.application-detail.paginate'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async createApplication({ commit }, payload) {
    return await apiService.post(route('member.fcs.application-detail.create'), payload)
  },
  async getFilterList({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.application-detail.filter-list'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async getApplicationCandidateFilterLists({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.application-detail.get-filter'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async recalculate({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.application-detail.recalculate'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
  async update({ commit }, payload) {
    const apiResult = await apiService.post(route('member.fcs.application-detail.update'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
